import { Injectable } from '@angular/core';

import { HttpService } from '../services/http.service';
import { SessionService } from '../services/session.service';
import { AppConfig } from '../entities/configs/app.config';
import { MenuConfig } from '../entities/configs/menu.config';

@Injectable()
export class BootService {
  constructor(
    private httpService: HttpService,
    private sessionService: SessionService
  ) {}

  boot() {
    return new Promise<void>((resolve, reject) => {
      console.debug('boot start.');
      this.getAppConfig().then(() => {
        this.getMenuConfig().then(() => {
          console.debug('boot end.');
          resolve();
        });
      });
    });
  }

  getAppConfig() {
    return new Promise<void>((resolve, reject) => {
      let config = this.sessionService.appConfig;
      if (config) {
        console.debug('config existed.');
        resolve();
        return;
      }
      this.httpService
        .get<AppConfig>('/assets/configs/app.config.json')
        .then((config) => {
          console.debug(config);
          this.sessionService.appConfig = config;
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject('请求AppConfig失败。');
        });
    });
  }

  getMenuConfig() {
    return new Promise<void>((resolve, reject) => {
      // let menus = this.sessionService.menus;
      let user: any = this.sessionService.user;
      let newmenus: any = [];
      // if (menus) {
      //   console.debug('menus existed.');
      //   resolve();
      //   return;
      // }
      this.httpService
        .get<MenuConfig[]>('/assets/configs/menu.config.json')
        .then((menus) => {
          if (user && user.account_code == 'spareadmin') {
            menus.map((v) => {
              if (v.text == '配件管理') {
                newmenus.push(v);
              }
            });
            this.sessionService.menus = newmenus;
          }else if (user &&user.account_type == 'SH') {
            menus.map((v) => {
              if (v.text == '工单查询') {
                newmenus.push(v);
              }if (v.text == 'PDA工单') {
                newmenus.push(v);
              }
            });
            this.sessionService.menus = newmenus;
          }else{
            this.sessionService.menus = menus;
          }
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject('请求Menu失败。');
        });
    });
  }
}
